export default __webpack_public_path__ + "static/media/lefteye.504f070f.svg";